import React from 'react';
import Select from '../../../../../Utility/FormElements/Select';
import Input from '../../../../../Utility/FormElements/Input';
import OAuthConfig from '../OAuthConfig';
import useGlobals from '../../../../../../Hooks/useGlobals';

type AuthType = 'none' | 'api_key' | 'oauth';

type Props = {
    configId?: string;
    authType: AuthType;
    authData: Record<string, any>;
    errors?: Record<string, string>;
    onAuthTypeChange: (authType: AuthType) => void;
    onAuthDataChange: (updates: Record<string, any>) => void;
    hasUnsavedChanges: boolean;
};

const AuthenticationSection: React.FC<Props> = ({
    configId,
    authType,
    authData,
    errors = {},
    onAuthTypeChange,
    onAuthDataChange,
    hasUnsavedChanges,
}) => {
    const { i18n } = useGlobals();
    const renderAuthFields = () => {
        switch (authType) {
            case 'api_key':
                return (
                    <div>
                        <label className="block text-sm font-medium text-layout-textcolor mb-2">
                            {i18n.translate({ id: 'auth.apiKey', sourceName: 'MCP' })} *
                        </label>
                        <Input
                            inputType="password"
                            value={authData.apiKey || ''}
                            onChange={(value) => onAuthDataChange({ apiKey: value })}
                            placeholder={i18n.translate({ id: 'auth.apiKey.placeholder', sourceName: 'MCP' })}
                            hasVisibilityButton={true}
                        />
                        {errors.apiKey && <span className="text-red-500 text-xs mt-1">{errors.apiKey}</span>}
                    </div>
                );
            case 'oauth':
                return (
                    <OAuthConfig
                        configId={configId || ''}
                        authData={authData}
                        onAuthDataChange={(data) => onAuthDataChange(data)}
                        authType={authType}
                        hasUnsavedChanges={hasUnsavedChanges}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div className="space-y-4">
            <div className="my-4">
                <h4>{i18n.translate({ id: 'form.authentication.title', sourceName: 'MCP' })}</h4>
            </div>

            <div>
                <label className="block text-sm font-medium text-layout-textcolor mb-2">
                    {i18n.translate({ id: 'form.authType.label', sourceName: 'MCP' })}
                </label>
                <Select value={authType} onChange={(value) => onAuthTypeChange(value as AuthType)}>
                    <option value="none">{i18n.translate({ id: 'auth.none', sourceName: 'MCP' })}</option>
                    <option value="api_key">{i18n.translate({ id: 'auth.apiKey', sourceName: 'MCP' })}</option>
                    <option value="oauth">{i18n.translate({ id: 'auth.oauth', sourceName: 'MCP' })}</option>
                </Select>
            </div>
            {renderAuthFields()}
        </div>
    );
};

export default AuthenticationSection;
